// @todo: Migrate to 'Switch' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const GridMode = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [mode, setMode] = useState(config.mode);
  const isChecked = mode === 'grid';

  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Grid mode"
        configField="mode"
        unsetConfigField={() => unsetConfigField('mode')}
      />
      <Switch.Root
        data-test="grid-mode-switch"
        checked={isChecked}
        onCheckedChange={newIsChecked => {
          const newMode = newIsChecked ? 'grid' : 'gallery';
          setMode(newMode);
          updateConfig({mode: newMode});
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
